<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 members-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div>
        <div class="breadcrumbs-section">
          <span class="prev-page  "><a routerLink="/overview">Home</a></span>
          <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
          <span class="curr-page breadcrumbs-section-font">Members</span>
        </div>
        <!-- <div class="d-flex justify-content-between meetings-layout"> -->
        <!-- <div class="meetings ">Members
            <br><span class="sub-label">{{totalCount}} Active members in the campus</span>
          </div> -->
        <div class=" meetings-layout">
          <div class="meetings ml-0 row">Members </div><br>

          <!-- <div class="row ml-0">
            <input type="radio" class=" mt-1 ml-0 mr-3" value="all" name="type" checked
              (change)="displayType($event.target.value)">
            <label for="all" class="radio-label">All</label>
            <input type="radio" class=" mt-1 ml-5 mr-3" value="active" name="type"
              (change)="displayType($event.target.value)">
            <label for="active" class="radio-label ">Active</label>
            <input type="radio" class=" mt-1 ml-5 mr-3" value="inactive" name="type"
              (change)="displayType($event.target.value)">
            <label for="inactive" class="radio-label">Inactive</label>
          </div> -->


          <div>
            <div class="form-check form-check-inline mr-4">
              <input type="radio" class="form-check-input" id="all" value="all" name="type" checked
                (change)="displayType($event.target.value)">
              <label for="all" class="form-check-label">All</label>
            </div>
            <div class="form-check form-check-inline mr-4">
              <input type="radio" class="form-check-input" id="active" value="active" name="type"
                (change)="displayType($event.target.value)">
              <label for="active" class="form-check-label">Active</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="inactive" value="inactive" name="type"
                (change)="displayType($event.target.value)">
              <label for="inactive" class="form-check-label">Inactive</label>
            </div>
          </div>

        </div>

        <div class="pt-3 margin-left overflow-hidden">
          <span class="pr-5 select-all">Bulk Email</span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="false" value="tableSelected" (change)="toggleBulkEmail()">
            <span class="slider round "></span>
          </label>
        </div>

        <!-- </div> -->
      </div>
      <div class="mt-4">
        <div class="col-12 row borders m-0 p-0 ">
          <div class="pt-3 pb-3 d-flex" [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual"
            #p="ngbPopover" (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
            popoverClass='dash-popover dashboard-popover'
            class="col-4 borders-right pt-3  pr-0 padding-left-meeting organization"> Organization
            <span class="d-flex justify-content-end"><img src="/assets/images/Path.png"
                class="padding-left-image pr-3 justify-content-between" /></span>
            <!-- <div class="all">{{selectedTenantName}}</div> -->

            <div class="all">{{selectedTenantName}} <span
                *ngIf="multiSelecttenant.length > 1">+{{multiSelecttenant.length - 1}}</span></div>

            <div>
              <ng-template #popContent>
                <div class="popupHeader">
                  <img src="../../assets/images/search.png">
                  <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                </div>
                <div class="template p-0 ">

                  <div class="dashboard-popover ">
                    <div class="d-flex justify-content-between ">
                      <div class="pl-3 pr-3 pb-3 ">
                        <!-- <div class="all ml-1 mb-2">All</div> -->
                        <div class="row pb-2" *ngFor="let company of companyList | filter: searchDept;let i=index">

                          <div class="popover-content pl-3 email-width col-11" (click)="selectEmailid(company)"
                            [class]="multiSelecttenant.includes(company?.id)?'bold-font':'normal-font'">
                            {{company?.companyName}}
                          </div>
                          <div class="col-1">
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelecttenant.includes(company?.id) || (company.id == null && multiSelecttenant.length == 0)"
                              class="" loading="lazy" />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>


          <div class="search-wrapper mt-3">
            <label for="search">
              <img class="image-pos pl-4" src="/assets/images/search.png" alt="search">
              <input class="search-box search-padding  pt-1" type="text" name="searchText" id="menu-search"
                [(ngModel)]="searchText" placeholder="Type here to search…" (keyup)="searchByText(searchText)"
                (search)="searchByText(searchText)">
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-between meetings-layout" *ngIf="bulkEmail">
        <div>
          <span class="sub-label">{{selectedCount}} of {{totalCount}} active members selected</span>
        </div>
        <div class="pt-2">

          <div class="select-padding ">
            <span class="send-invitation-via">Select all</span>
            <label class="switch-checkbox ">
              <input type="checkbox" class="styled-checkbox gaps" name="dob" id="dobRadioButton"
                (change)="toggleSelectAllSelection($event)" />
              <label for="dobRadioButton" class="send-invitation-via"></label>
            </label>
            <!-- <input type="checkbox" class="styled-checkbox gaps" name="dob" id="dobRadioButton" />
                <label for="dobRadioButton" class="send-invitation-via">Send invitation via Email</label>
                <input type="checkbox" class="styled-checkbox gaps" name="dob" id="dobRadioButton" /> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-12 loader-margin" *ngIf="showLoader">
        <div class="loader"></div>
      </div> -->

      <div class="sub-label margin-left mt-3">{{totalCount}} {{text}} members in the campus</div>

      <div class="layout-height pt-3 c2 scroll-position">
        <ng-template [ngIf]="members && members?.list && members?.list.length">
          <div class="meetings-layout pb-4"
            *ngFor="let member of membersTempNew | filter:searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems:totalCount }">
            <div class=" row-color">
              <div class="d-flex justify-content-between pt-3 ">
                <div class="col-1 pl-4 pr-0" *ngIf="member?.profileUrl !=null">
                  <img class="person-image" [src]="member.profileUrl" />
                </div>
                <div class="col-1 pl-4 pr-0" *ngIf="member?.profileUrl ==null">
                  <div class="circle">
                    <div class="circle-name">{{getName(member?.userName)}}</div>
                  </div>
                </div>
                <div class=" pt-2" [ngClass]="bulkEmail?'col-9':'col-8'">
                  <span class="meeting-room-name pointer-link" style="word-break: break-all;"
                    (click)="openMemberDetail(member)">{{maskName(member.userName)|titlecase}}
                    <br><span class="pr-1 meeting-time">{{member.department}}</span> <span *ngIf="member.department"
                      class="pl-1 verticalLine-details"></span>
                    <span class="meeting-time pr-1">{{maskPhone(member.phoneNumber)}}</span>
                    <span class="pl-1 verticalLine-details"></span>
                    <!-- <span class="meeting-time pr-1">{{member.location}}</span> -->
                    <!-- <span class="pl-1 pr-1 verticalLine-details"></span> -->
                    <span class="meeting-time">{{member.t0200OrgEmployees[0]?.tenant?.companyName}}</span>
                  </span>
                </div>
                <div class="justify-content-end col-1 pt-3" *ngIf="bulkEmail">
                  <!-- <span> -->
                  <label class="emailCheckbox ">
                    <input type="checkbox" (click)="changeState(member)" name="email"
                      id="{{'sendEmail'+member?.userId}}" [checked]="selectedMembers.indexOf(member?.userId)>=0"
                      [value]="selectedMembers.indexOf(member?.userId) >= 0" />
                    <span class="checkmark"></span>
                    <!-- <input type="checkbox" class="styled-checkbox gaps"
                                        id="{{'sendEmail'+index}}" name="sendEmail"
                                        (change)="changeState(member,$event.target.checked)"
                                        [checked]="member.selected" /> -->
                    <!-- <label for="emailsend" class="send-invitation-via"></label> -->
                  </label>
                  <!-- </span> -->
                </div>
                <!-- <button (click)="showAlert()">show alert</button> -->
                <!-- <div class="alert" [class.visible]="isVisible">
                                JWT copied to clipboard
                              </div> -->
                <div class="justify-content-end col-2 mr-5 pt-3" *ngIf="!bulkEmail">
                  <button class="alert-button" (click)="emailClick(member)">
                    <div class="rectangle-select">
                      <span class="email">Email</span>
                    </div>
                    <span>
                      <img class="image-pos-cross" src="/assets/images/email.png"></span>

                  </button>
                  <div class="alert" [class.visible]="isVisible">
                    <img src="/assets/images/email-success.png"><span class="pl-2">Email sent successfully</span>
                  </div>

                  <!-- <ng-template #emailmessage let-modal class="text-center" >
                                    <div class="modal-height">
                                      <div class="modal-body">
                                          <div class="">
                                            <div class="text pt-3 pb-3">Are you sure, you want to revoke invitation</div>
                                            <div class="popup-line"></div>
                                          </div>
                                      </div>
                                    </div>
                                    </ng-template> -->
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <!-- <div>
                <span class="pagination-numbers">10/100</span>

            </div> -->
      <div class="d-flex justify-content-center mt-4 mb-4" style="margin:30px 0px" *ngIf="totalCount > 10">
        <div class="row d-flex pagination-border">
          <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
            class="d-flex justify-content-center">
          </pagination-controls>
          <!-- <div class="pr-3 ratio-class pt-1">{{page}}/{{totalCount}}</div> -->
          <div class="pr-3 ratio-class pt-1">{{page}}/{{displayCount}}</div>
        </div>
      </div>

      <div class="d-flex justify-content-between meetings-layout button-footer" *ngIf="selectedCount!=0">
        <div class="sub-label pt-4">{{selectedCount}} of {{totalCount}} active members selected
        </div>
        <div class="pt-3">
          <button class="add-button" (click)="emailBulkClick()">
            <span class="add">Send Email</span>
          </button>
        </div>
      </div>

      <!-- <ngb-pagination [pageSize] = "25" [collectionSize]="100" [(page)]="page" aria-label="Default pagination"></ngb-pagination> -->
    </div>
  </div>
  <!-- <div *ngIf="emailShow">
        <app-email-members [member]="emailIdlist"></app-email-members>
    </div> -->
</div>